import React from 'react'
import Confetti from 'react-confetti'

/**
 * A one-shot burst when winners land. Keyed on the first winner's id so each draw gets a fresh
 * one: `recycle={false}` falls once and stops, and React would otherwise reuse the spent instance.
 */
const WinnerConfetti = ({ winners }) => {
  if (winners.length === 0) return null

  return (
    <Confetti
      key={winners[0].id}
      recycle={false}
      // Each piece is a canvas draw per frame, on the same main thread as the wall. A few hundred
      // still reads as a burst on a projector; fourteen hundred cost frames for nothing.
      numberOfPieces={Math.min(220 + winners.length * 25, 420)}
      gravity={0.22}
      colors={['#f7c948', '#ffffff', '#ffe9a8', '#e0a800', '#fff6dc']}
      // Over MUI's modal layer (1300) so it falls in front of the dialog, under the snackbar
      // layer (1400) so an error stays readable.
      style={{ position: 'fixed', top: 0, left: 0, zIndex: 1301, pointerEvents: 'none' }}
    />
  )
}

export default WinnerConfetti
